/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { OralExamEventKindDefaults } from './oralExamEventKindDefaults';

export type EventKindOralExamDefaults = OralExamEventKindDefaults | null;
